import React from "react";
import I1 from "../../Images/New/RightSoft/1.png";
import I2 from "../../Images/New/RightSoft/2.png";
import I3 from "../../Images/New/RightSoft/3.png";
import I4 from "../../Images/New/RightSoft/4.png";
import I5 from "../../Images/New/RightSoft/5.png";
import I6 from "../../Images/New/RightSoft/6.png";
import I7 from "../../Images/New/RightSoft/7.png";
import I8 from "../../Images/New/RightSoft/8.png";
import I9 from "../../Images/New/RightSoft/9.png";
import I10 from "../../Images/New/RightSoft/10.png";
import Right from "../../Images/RightSvg.svg";

function RightSoft() {
  const [expandedIndex, setExpandedIndex] = React.useState(-1);

  const handleClick = (index) => {
    if (expandedIndex === index) {
      setExpandedIndex(-1);
    } else {
      setExpandedIndex(index); 
    }
  };

  let ListItem = React.memo(({ text }) => (
    <li className="flex gap-x-3 items-start text-lg">
      <img src={Right} className="mt-[6px]" alt="" />
      <span>
        <strong className="font-semibold text-gray-900"> {text} </strong>
      </span>
    </li>
  ));

  const faqDataLeft = [
    {
      question: "Invoicing and Accounting",
      answer: [
        "Create GST compliant Invoice",
        "Multiple Template for Invoice as per user requirement",
        "Preparation of Order form and Quotation",
        "Option to view Customer's outstanding Bills & Sales history of goods, including the last price at which the goods were sold",
        "Goods / Services price with Inclusive / Exclusive Tax",
        "Invoice to Payment Process",
      ],
      img: I1,
    },
    {
      question: "Receivable & Payables",
      answer: [
        "Every transaction details and track business cash flow seamlessly",
        "Settle Multiple Bill against a payment",
        "Interest Calculation for early or delayed payments",
        "Credit Period Management",
        "Payment Due Register",
      ],
      img: I2,
    },
    {
      question: "Bank Management",
      answer: [
        "Auto Bank Reconciliation",
        "Generate Pay in slips and Cheque management",
        "Import Bank statements through Excel sheets",
        "Cheque Printing option",
      ],
      img: I3,
    },
    {
      question: "TDS Management",
      answer: [
        "Deduction of TDS as per the norms",
        "Generation of TDS Reports & Export in Excel",
      ],
      img: I4,
    },
    {
      question: "E-invoicing",
      answer: [
        "Generate E-invoices",
        "Bulk E-invoice direct upload facility",
        "E-Invoice reports",
        "Cancel uploaded e-invoices",
      ],
      img: I5,
    },
    {
      question: "Printing Modules",
      answer: [
        "Challan printing",
        "Half page Invoice printing",
        "Envelop Printing",
      ],
      img: I6,
    },
    {
      question: "Discount / Commission calculation & Reports",
      answer: [
        "Agent-wise / Sales person wise Commission calculation & Reports",
        "Auto calculation of Discounts",
      ],
      img: I7,
    },
    {
      question: "Multi-Account Management",
      answer: [
        "Multiple companies",
        "Multiple Group Company",
        "Multiple Bank accounts",
      ],
      img: I8,
    },
    {
      question: "Tax Compliance",
      answer: [
        "EasyACC helps you manage statutory compliances such as GST or TDS along with Multiple Tax Rates, Tax Categories & ledgers",
      ],
      img: I9,
    },
    {
      question: "Other Features",
      answer: [
        "Digital signature on invoices and reports",
        "Collect previous FY data to current year",
        "Automatic Data backup and restore",
        "User wise Data Access Management",
        "Technical Support",
        "User-Friendly Dashboard",
      ],
      img: I10,
    },
  ];

  return (
    <div className="sm:flex py-20 sm:px-10 bg-[#ffffff] relative items-center mt-[1000px] sm:mt-0">
      <div className="w-full px-5 flex justify-center">
        <div className="bg-white border-2 rounded-2xl shadow-xl px-3 sm:px-12 pb-3 sm:pb-10 w-full max-w-7xl">
          <div className="flex flex-col items-center">
            <p className="font-bold text-4xl sm:text-5xl mt-10 tracking-tight">
              <span
                className=""
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                Billing Software
              </span>{" "}
              for Small Businesses in India
            </p>
          </div>
          <div className="grid grid-cols-1 items-start sm:grid-cols-2 px-3 sm:px-0 w-full mt-10 sm:mt-20 gap-4 ">
            {faqDataLeft.map((faq, index) => (
              <div
                key={index}
                className={`faq-item bg-white border-2 rounded-xl overflow-hidden ${
                  expandedIndex === index ? "border-[#02aee6]" : ""
                }`}
              >
                <summary
                  className="flex justify-between text-xl items-center font-medium cursor-pointer list-none bg-white p-4"
                  onClick={() => handleClick(index)}
                >
                  <span className="flex items-center">
                    <img className="h-12 w-12 mr-5" src={faq.img} alt="" />
                    <span>{faq.question}</span>
                  </span>
                  <span className="transition bg-[#0077b3] rounded-full p-2">
                    <svg
                      fill="none"
                      height="24"
                      shapeRendering="geometricPrecision"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M6 9l6 6 6-6"></path>
                    </svg>
                  </span>
                </summary>
                {expandedIndex === index && (
                  <div className="answer p-4 bg-white">
                    {faq.answer.map((item, idx) => (
                      <ListItem key={idx} text={item} />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RightSoft;
